var _path, _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.26342 6.5H21.7365C22.2944 6.5 22.7505 6.95608 22.7505 7.514V7.65267C22.7505 8.21058 22.2944 8.66667 21.7365 8.66667H4.26342C3.7055 8.66667 3.2505 8.21058 3.2505 7.65267V7.514C3.2505 6.95608 3.7055 6.5 4.26342 6.5ZM5.41667 13C5.41667 13.5991 4.93133 14.0833 4.33333 14.0833C3.73533 14.0833 3.25 13.5991 3.25 13C3.25 12.4009 3.73533 11.9167 4.33333 11.9167C4.93133 11.9167 5.41667 12.4009 5.41667 13ZM8.59679 11.9167H21.7365C22.2945 11.9167 22.7505 12.3728 22.7505 12.9307V13.0693C22.7505 13.6273 22.2945 14.0833 21.7365 14.0833H8.59679C8.03887 14.0833 7.58387 13.6273 7.58387 13.0693V12.9307C7.58387 12.3728 8.03887 11.9167 8.59679 11.9167ZM21.7365 17.3333H4.26346C3.70554 17.3333 3.25054 17.7894 3.25054 18.3473V18.486C3.25054 19.0439 3.70554 19.5 4.26346 19.5H21.7365C22.2945 19.5 22.7505 19.0439 22.7505 18.486V18.3473C22.7505 17.7894 22.2945 17.3333 21.7365 17.3333Z",
    fill: "black"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 6,
    width: 20,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.26342 6.5H21.7365C22.2944 6.5 22.7505 6.95608 22.7505 7.514V7.65267C22.7505 8.21058 22.2944 8.66667 21.7365 8.66667H4.26342C3.7055 8.66667 3.2505 8.21058 3.2505 7.65267V7.514C3.2505 6.95608 3.7055 6.5 4.26342 6.5ZM5.41667 13C5.41667 13.5991 4.93133 14.0833 4.33333 14.0833C3.73533 14.0833 3.25 13.5991 3.25 13C3.25 12.4009 3.73533 11.9167 4.33333 11.9167C4.93133 11.9167 5.41667 12.4009 5.41667 13ZM8.59679 11.9167H21.7365C22.2945 11.9167 22.7505 12.3728 22.7505 12.9307V13.0693C22.7505 13.6273 22.2945 14.0833 21.7365 14.0833H8.59679C8.03887 14.0833 7.58387 13.6273 7.58387 13.0693V12.9307C7.58387 12.3728 8.03887 11.9167 8.59679 11.9167ZM21.7365 17.3333H4.26346C3.70554 17.3333 3.25054 17.7894 3.25054 18.3473V18.486C3.25054 19.0439 3.70554 19.5 4.26346 19.5H21.7365C22.2945 19.5 22.7505 19.0439 22.7505 18.486V18.3473C22.7505 17.7894 22.2945 17.3333 21.7365 17.3333Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.f8141ced.svg";
export { ForwardRef as ReactComponent };